<template>
  <div class="seller-auth-shell">
    <section class="seller-auth-hero">
      <p class="eyebrow">dashcom seller onboarding</p>
      <h1>创建卖家空间，把你的商品和服务搬进来。</h1>
      <p>开店后可以立刻管理商品、订单、分类、营销活动，以及 AI 试衣能力。</p>
    </section>

    <div class="seller-auth-card card">
      <h2>卖家注册</h2>

      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>

      <div v-if="success" class="alert alert-success">
        {{ success }}
      </div>

      <form @submit.prevent="register">
        <div class="form-group">
          <label for="username">用户名</label>
          <input id="username" v-model="username" type="text" required placeholder="请输入卖家用户名">
        </div>
        <div class="form-group">
          <label for="password">密码</label>
          <input id="password" v-model="password" type="password" required placeholder="请输入密码">
        </div>
        <div class="form-group">
          <label for="confirmPassword">确认密码</label>
          <input id="confirmPassword" v-model="confirmPassword" type="password" required placeholder="请再次输入密码">
        </div>
        <div class="form-group">
          <label for="shopName">店铺名称</label>
          <input id="shopName" v-model="shopName" type="text" required placeholder="请输入店铺名称">
        </div>
        <div class="form-group">
          <label for="contactName">联系人姓名</label>
          <input id="contactName" v-model="contactName" type="text" required placeholder="请输入联系人姓名">
        </div>
        <div class="form-group">
          <label for="contactPhone">联系电话</label>
          <input id="contactPhone" v-model="contactPhone" type="text" required placeholder="请输入联系电话">
        </div>
        <div class="form-group">
          <label for="address">店铺地址</label>
          <input id="address" v-model="address" type="text" required placeholder="请输入店铺地址">
        </div>
        <button type="submit" class="btn primary-btn">注册</button>
        <div class="form-footer">
          已有账号？
          <router-link to="/seller/login">立即登录</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SellerRegister',
  data() {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      shopName: '',
      contactName: '',
      contactPhone: '',
      address: '',
      error: '',
      success: ''
    }
  },
  created() {
    if (localStorage.getItem('sellerToken')) {
      this.$router.push('/seller/dashboard')
    }
  },
  methods: {
    async register() {
      if (this.password !== this.confirmPassword) {
        this.error = '两次输入的密码不一致'
        return
      }

      try {
        const sellerData = {
          username: this.username,
          password: this.password,
          shopName: this.shopName,
          contactName: this.contactName,
          contactPhone: this.contactPhone,
          address: this.address,
          isActive: true
        }

        const response = await this.$axios.post('/seller/register', sellerData)

        if (response.data.success) {
          this.success = '注册成功，请登录卖家端'
          this.error = ''
          setTimeout(() => {
            this.$router.push('/seller/login')
          }, 2000)
        } else {
          this.error = response.data.message || '注册失败，请重试'
        }
      } catch (err) {
        this.error = err.response?.data?.message || '注册失败，请重试'
        console.error(err)
      }
    }
  }
}
</script>

<style scoped>
.seller-auth-shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(400px, 520px);
  gap: 1.4rem;
  align-items: stretch;
  min-height: calc(100vh - 220px);
}

.seller-auth-hero,
.seller-auth-card {
  border-radius: 32px;
}

.seller-auth-hero {
  padding: 2rem;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.32)),
    radial-gradient(circle at 18% 20%, rgba(0, 113, 227, 0.16), transparent 30%),
    linear-gradient(180deg, rgba(250, 250, 252, 0.95), rgba(236, 239, 244, 0.84));
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: var(--shadow-medium);
}

.eyebrow {
  margin: 0 0 0.8rem;
  color: var(--color-text-faint);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.seller-auth-hero h1 {
  margin: 0;
  max-width: 11ch;
  font-size: clamp(2.3rem, 4vw, 3.8rem);
  line-height: 1;
  letter-spacing: -0.05em;
  color: var(--color-text);
}

.seller-auth-hero p:last-child {
  max-width: 500px;
  margin: 1rem 0 0;
  color: var(--color-text-soft);
  line-height: 1.8;
}

.seller-auth-card {
  width: 100%;
  margin: 0;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.75);
  box-shadow: var(--shadow-soft);
}

.seller-auth-card h2 {
  margin: 0 0 1.5rem;
  color: var(--color-text);
  font-size: 1.8rem;
  letter-spacing: -0.03em;
}

.primary-btn {
  width: 100%;
  min-height: 52px;
}

.form-footer {
  margin-top: 1rem;
  text-align: center;
  color: var(--color-text-soft);
}

.form-footer a {
  color: var(--color-accent-strong);
  text-decoration: none;
  font-weight: 600;
}

.form-footer a:hover {
  text-decoration: underline;
}

@media (max-width: 900px) {
  .seller-auth-shell {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .seller-auth-hero,
  .seller-auth-card {
    border-radius: 24px;
  }
}
</style>
